import type { MailboxInfo } from 'owa-client-types';
import { isUnifiedInboxMailboxInfo } from 'owa-client-types/lib/UnifiedInboxMailboxInfo';
import { isSameMailboxInfo } from 'owa-account-source-list-store';

export function getUniqueMailboxInfoOrDefault(
    defaultMailboxInfo: MailboxInfo,
    itemsMailboxInfo: MailboxInfo[]
): MailboxInfo {
    if (isUnifiedInboxMailboxInfo(defaultMailboxInfo)) {
        for (let i = 1; i < itemsMailboxInfo.length; i++) {
            if (!isSameMailboxInfo(itemsMailboxInfo[i - 1], itemsMailboxInfo[i])) {
                return defaultMailboxInfo;
            }
        }
        // If all mailboxInfos are the same, return the first one
        return itemsMailboxInfo[0];
    }

    return defaultMailboxInfo;
}
